//QUOTES
export const GET_QUOTES_SUGGESTIONS = 'GET_QUOTES_SUGGESTIONS';
export const GET_QUOTES_SUGGESTIONS_SUCCESS = 'GET_QUOTES_SUGGESTIONS_SUCCESS';
export const GET_QUOTES_SUGGESTIONS_FAILED = 'GET_QUOTES_SUGGESTIONS_FAILED';
export const CHANGE_QUOTES_STATE = 'CHANGE_QUOTES_STATE';
export const QUOTES_LIST_PAGE_SHIFT = 'QUOTES_LIST_PAGE_SHIFT';
export const CHANGE_QUOTES_LIST_PAGE = 'CHANGE_QUOTES_LIST_PAGE';
export const GET_QUOTES = 'GET_QUOTES';
export const GET_QUOTES_SUCCESS = 'GET_QUOTES_SUCCESS';
export const GET_QUOTES_FAILED = 'GET_QUOTES_FAILED';
export const CLEAR_QUOTES_FILTERS = 'CLEAR_QUOTES_FILTERS';

// QUOTE
export const GET_QUOTE_SCHEDULE_INFO = 'GET_QUOTE_SCHEDULE_INFO';
export const GET_QUOTE_SCHEDULE_INFO_SUCCESS = 'GET_QUOTE_SCHEDULE_INFO_SUCCESS';
export const GET_QUOTE_SCHEDULE_INFO_FAILED = 'GET_QUOTE_SCHEDULE_INFO_FAILED';
export const GET_QUOTE_PROPOSAL_FORMS = 'GET_QUOTE_PROPOSAL_FORMS';
export const GET_QUOTE_PROPOSAL_FORMS_SUCCESS = 'GET_QUOTE_PROPOSAL_FORMS_SUCCESS';
export const GET_QUOTE_PROPOSAL_FORMS_FAILED = 'GET_QUOTE_PROPOSAL_FORMS_FAILED';
export const GET_QUOTE_POLICY_WORDINGS = 'GET_QUOTE_POLICY_WORDINGS';
export const GET_QUOTE_POLICY_WORDINGS_SUCCESS = 'GET_QUOTE_POLICY_WORDINGS_SUCCESS';
export const GET_QUOTE_POLICY_WORDINGS_FAILED = 'GET_QUOTE_PPOLICY_WORDINGS_FAILED';
export const GET_QUOTE_POINTS_OF_SALE = 'GET_QUOTE_POINTS_OF_SALE';
export const GET_QUOTE_POINTS_OF_SALE_SUCCESS = 'GET_QUOTE_POINTS_OF_SALE_SUCCESS';
export const GET_QUOTE_POINTS_OF_SALE_FAILED = 'GET_QUOTE_POINTS_OF_SALE_FAILED';
export const SEND_QUOTE_SCHEDULE_VIA_EMAIL = 'SEND_QUOTE_SCHEDULE_VIA_EMAIL';
export const SEND_QUOTE_SCHEDULE_VIA_EMAIL_SUCCESS = 'SEND_QUOTE_SCHEDULE_VIA_EMAIL_SUCCESS';
export const SEND_QUOTE_SCHEDULE_VIA_EMAIL_FAILED = 'SEND_QUOTE_SCHEDULE_VIA_EMAIL_FAILED';
export const RESET_QUOTE_STATE = 'RESET_QUOTE_STATE';
export const GET_QUOTE_SCHEDULES_MESSAGE = 'GET_QUOTE_SCHEDULES_MESSAGE';
export const GET_QUOTE_SCHEDULES_MESSAGE_SUCCESS = 'GET_QUOTE_SCHEDULES_MESSAGE_SUCCESS';
export const GET_QUOTE_SCHEDULES_MESSAGE_FAILED = 'GET_QUOTE_SCHEDULES_MESSAGE_FAILED';
export const RESET_QUOTE_OPTIONS = 'RESET_QUOTE_OPTIONS';
export const GET_QUOTE_BY_ID = 'GET_QUOTE_BY_ID';
export const GET_QUOTE_BY_ID_SUCCESS = 'GET_QUOTE_BY_ID_SUCCESS';
export const GET_QUOTE_BY_ID_FAILED = 'GET_QUOTE_BY_ID_FAILED';
export const GET_QUOTE_POLICY_OVERVIEW = 'GET_QUOTE_POLICY_OVERVIEW';
export const GET_QUOTE_POLICY_OVERVIEW_SUCCESS = 'GET_QUOTE_POLICY_OVERVIEW_SUCCESS';
export const GET_QUOTE_POLICY_OVERVIEW_FAILED = 'GET_QUOTE_POLICY_OVERVIEW_FAILED';
export const COPY_QUOTE = 'COPY_QUOTE';
export const GET_QUOTE_MESSAGES = 'GET_QUOTE_MESSAGES';
export const GET_QUOTE_MESSAGES_SUCCESS = 'GET_QUOTE_MESSAGES_SUCCESS';
export const GET_QUOTE_MESSAGES_FAILED = 'GET_QUOTE_MESSAGES_FAILED';
export const GET_QUOTE_DEFAULT_SETTINGS = 'GET_QUOTE_DEFAULT_SETTINGS';
export const GET_QUOTE_DEFAULT_SETTINGS_SUCCESS = 'GET_QUOTE_DEFAULT_SETTINGS_SUCCESS';
export const GET_QUOTE_DEFAULT_SETTINGS_FAILED = 'GET_QUOTE_DEFAULT_SETTINGS_FAILED';
export const GET_QUOTE_IPT = 'GET_QUOTE_IPT';
export const GET_QUOTE_IPT_SUCCESS = 'GET_QUOTE_IPT_SUCCESS';
export const GET_QUOTE_IPT_FAILED = 'GET_QUOTE_IPT_FAILED';
export const HANDLE_QUOTE_PRODUCTS_CHANGE = 'HANDLE_QUOTE_PRODUCTS_CHANGE';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const UPDATE_QUOTE_SUCCESS = 'UPDATE_QUOTE_SUCCESS';
export const UPDATE_QUOTE_FAILED = 'UPDATE_QUOTE_FAILED';
export const CHANGE_QUOTE_REQUIRED = 'CHANGE_QUOTE_REQUIRED';
export const CHANGE_BROKER_COMMISSION = 'CHANGE_BROKER_COMMISSION';
export const CREATE_QUOTE = 'CREATE_QUOTE';
export const CREATE_QUOTE_SUCCESS = 'CREATE_QUOTE_SUCCESS';
export const CREATE_QUOTE_FAILED = 'CREATE_QUOTE_FAILED';
export const CHANGE_QUOTE_CLIENT_DETAILS_FORM = 'CHANGE_QUOTE_CLIENT_DETAILS_FORM';
export const GET_QUOTE_STATUSES = 'GET_QUOTE_STATUSES';
export const GET_QUOTE_STATUSES_SUCCESS = 'GET_QUOTE_STATUSES_SUCCESS';
export const GET_QUOTE_STATUSES_FAILED = 'GET_QUOTE_STATUSES_FAILED';
export const GET_QUOTE_QUESTIONS = 'GET_QUOTE_QUESTIONS';
export const GET_QUOTE_QUESTIONS_SUCCESS = 'GET_QUOTE_QUESTIONS_SUCCESS';
export const GET_QUOTE_QUESTIONS_FAILED = 'GET_QUOTE_QUESTIONS_FAILED';
export const CHANGE_QUOTE_STATE = 'CHANGE_QUOTE_STATE';
export const GET_QUOTE_MINIMUM_PRICING = 'GET_QUOTE_MINIMUM_PRICING';
export const GET_QUOTE_MINIMUM_PRICING_SUCCESS = 'GET_QUOTE_MINIMUM_PRICING_SUCCESS';
export const GET_QUOTE_MINIMUM_PRICING_FAILED = 'GET_QUOTE_MINIMUM_PRICING_FAILED';

//BROKERS
export const SORT_BROKERS = 'SORT_BROKERS';
export const GET_BROKERS_SUGGESTIONS = 'GET_BROKERS_SUGGESTIONS';
export const GET_BROKERS_SUGGESTIONS_SUCCESS = 'GET_BROKERS_SUGGESTIONS_SUCCESS';
export const GET_BROKERS_SUGGESTIONS_FAILED = 'GET_BROKERS_SUGGESTIONS_FAILED';
export const CHANGE_BROKERS_LIST_PAGE = 'CHANGE_BROKERS_LIST_PAGE';
export const BROKERS_LIST_PAGE_SHIFT = 'BROKERS_LIST_PAGE_SHIFT';
export const CHANGE_BROKERS_STATE = 'CHANGE_BROKERS_STATE';
export const GET_BROKERS = 'GET_BROKERS';
export const GET_BROKERS_SUCCESS = 'GET_BROKERS_SUCCESS';
export const GET_BROKERS_FAILED = 'GET_BROKERS_FAILED';

//BROKER FIRMS
export const GET_BROKER_FIRMS_WITH_AGENTS = 'GET_BROKER_FIRMS_WITH_AGENTS';
export const GET_BROKER_FIRMS_WITH_AGENTS_SUCCESS = 'GET_BROKER_FIRMS_WITH_AGENTS_SUCCESS';
export const GET_BROKER_FIRMS_WITH_AGENTS_FAILED = 'GET_BROKER_FIRMS_WITH_AGENTS_FAILED';
export const GET_BROKER_FIRMS = 'GET_BROKER_FIRMS';
export const GET_BROKER_FIRMS_SUCCESS = 'GET_BROKER_FIRMS_SUCCESS';
export const GET_BROKER_FIRMS_FAILED = 'GET_BROKER_FIRMS_FAILED';
export const GET_BROKER_FIRMS_POSTCODES = 'GET_BROKER_FIRMS_POSTCODES';
export const GET_BROKER_FIRMS_POSTCODES_SUCCESS = 'GET_BROKER_FIRMS_POSTCODES_SUCCESS';
export const GET_BROKER_FIRMS_POSTCODES_FAILED = 'GET_BROKER_FIRMS_POSTCODES_FAILED';

//BROKER
export const UPDATE_BROKER_PASSWORD = 'UPDATE_BROKER_PASSWORD';
export const UPDATE_BROKER_PASSWORD_SUCCESS = 'UPDATE_BROKER_PASSWORD_SUCCESS';
export const UPDATE_BROKER_PASSWORD_FAILED = 'UPDATE_BROKER_PASSWORD_FAILED';
export const CHANGE_BROKER_PASSWORD = 'CHANGE_BROKER_PASSWORD';
export const OPEN_BROKER_PASSWORD_MODAL = 'OPEN_BROKER_PASSWORD_MODAL';
export const CLOSE_BROKER_PASSWORD_MODAL = 'CLOSE_BROKER_PASSWORD_MODAL';
export const UPDATE_BROKER_BY_ID = 'UPDATE_BROKER_BY_ID';
export const UPDATE_BROKER_BY_ID_SUCCESS = 'UPDATE_BROKER_BY_ID_SUCCESS';
export const UPDATE_BROKER_BY_ID_FAILED = 'UPDATE_BROKER_BY_ID_FAILED';
export const GET_BROKER_BY_ID = 'GET_BROKER_BY_ID';
export const GET_BROKER_BY_ID_SUCCESS = 'GET_BROKER_BY_ID_SUCCESS';
export const GET_BROKER_BY_ID_FAILED = 'GET_BROKER_BY_ID_FAILED';
export const CHANGE_BROKER_STATE = 'CHANGE_BROKER_STATE';
export const CREATE_BROKER = 'CREATE_BROKER';
export const CREATE_BROKER_SUCCESS = 'CREATE_BROKER_SUCCESS';
export const CREATE_BROKER_FAILED = 'CREATE_BROKER_FAILED';
export const CHANGE_BROKER = 'CHANGE_BROKER';

export const UNLOCK_BROKER = 'UNLOCK_BROKER';
export const UNLOCK_BROKER_SUCCESS = 'UNLOCK_BROKER_SUCCESS';
export const UNLOCK_BROKER_FAILED = 'UNLOCK_BROKER_FAILED';
// WORDING CATEGORIES
export const FETCH_WORDING_CATEGORIES = 'FETCH_WORDING_CATEGORIES';
export const FETCH_WORDING_CATEGORIES_SUCCESS = 'FETCH_WORDING_CATEGORIES_SUCCESS';
export const FETCH_WORDING_CATEGORIES_FAILED = 'FETCH_WORDING_CATEGORIES_FAILED';

//PENDING APPROVALS
export const CLEAR_PENDING_CHANGES_ERROR_STATE = 'CLEAR_PENDING_CHANGES_ERROR_STATE';
export const CHANGE_PENDING_CHANGES_STORE = 'CHANGE_PENDING_APPROVALS_STATE';
export const FETCH_PENDING_CHANGES = 'FETCH_PENDING_CHANGES';
export const FETCH_PENDING_CHANGES_SUCCESS = 'FETCH_PENDING_CHANGES_SUCCESS';
export const FETCH_PENDING_CHANGES_FAILED = 'FETCH_PENDING_CHANGES_FAILED';
export const MODERATE_PENDING_CHANGE = 'MODERATE_PENDING_CHANGE';
export const MODERATE_PENDING_CHANGE_SUCCESS = 'MODERATE_PENDING_CHANGE_SUCCESS';
export const MODERATE_PENDING_CHANGE_FAILED = 'MODERATE_PENDING_CHANGE_FAILED';
export const CHANGE_PENDING_CHANGE_STATE = 'CHANGE_PENDING_CHANGE_STATE';
export const CHANGE_PENDING_CHANGE_STATE_SUCCESS = 'CHANGE_PENDING_CHANGE_STATE_SUCCESS';
export const CHANGE_PENDING_CHANGE_STATE_FAILED = 'CHANGE_PENDING_CHANGE_STATE_FAILED';
//EDITING SETTINGS
export const FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS = 'FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS';
export const FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_SUCCESS = 'FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_SUCCESS';
export const FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_FAILED = 'FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_FAILED';
export const FETCH_EDITING_SETTINGS = 'FETCH_EDITING_SETTINGS';
export const FETCH_EDITING_SETTINGS_SUCCESS = 'FETCH_EDITING_SETTINGS_SUCCESS';
export const FETCH_EDITING_SETTINGS_FAILED = 'FETCH_EDITING_SETTINGS_FAILED';
export const CHANGE_EDITING_SETTINGS = 'CHANGE_EDITING_SETTINGS';
export const UPDATE_EDITING_SETTINGS = 'UPDATE_EDITING_SETTINGS';
export const UPDATE_EDITING_SETTINGS_SUCCESS = 'UPDATE_EDITING_SETTINGS_SUCCESS';
export const UPDATE_EDITING_SETTINGS_FAILED = 'UPDATE_EDITING_SETTINGS_FAILED';
//MANAGE USER ACCOUNT
export const CHANGE_MANAGE_USER_ACCOUNT_SETTINGS = 'CHANGE_MANAGE_USER_ACCOUNT_SETTINGS';

//GENERAL
export const OPEN_ADMIN_BURGER_MENU = 'OPEN_ADMIN_BURGER_MENU';
export const CLOSE_ADMIN_BURGER_MENU = 'CLOSE_ADMIN_BURGER_MENU';
export const OPEN_SOLICITOR_USER_BURGER_MENU = 'OPEN_SOLICITOR_USER_BURGER_MENU';
export const CLOSE_USER_BURGER_MENU = 'CLOSE_USER_BURGER_MENU';
export const OPEN_ARAG_USER_BURGER_MENU = 'OPEN_ARAG_USER_BURGER_MENU';
export const CLOSE_ARAG_USER_BURGER_MENU = 'CLOSE_ARAG_USER_BURGER_MENU';
export const OPEN_ARAG_USER_SETTINGS_MENU = 'OPEN_ARAG_USER_SETTINGS_MENU';
export const CLOSE_ARAG_USER_SETTINGS_MENU = 'CLOSE_ARAG_USER_SETTINGS_MENU';
export const CHANGE_GENERAL_STORE_SETTINGS = 'CHANGE_GENERAL_STORE_SETTINGS';
//TOBA
export const OPEN_UPDATE_TOBA_CONFIRM_MODAL = 'OPEN_UPDATE_TOBA_CONFIRM_MODAL';
export const CLOSE_UPDATE_TOBA_CONFIRM_MODAL = 'CLOSE_UPDATE_TOBA_CONFIRM_MODAL';
export const OPEN_CREATE_REVISION_CONFIRM_MODAL = 'OPEN_CREATE_REVISION_CONFIRM_MODAL';
export const CLOSE_CREATE_REVISION_CONFIRM_MODAL = 'CLOSE_CREATE_REVISION_CONFIRM_MODAL';
export const GET_TOBA_REVISION_BY_ID = 'GET_TOBA_REVISION_BY_ID';
export const GET_TOBA_REVISION_BY_ID_SUCCESS = 'GET_TOBA_REVISION_BY_ID_SUCCESS';
export const GET_TOBA_REVISION_BY_ID_FAIL = 'GET_TOBA_REVISION_BY_ID_FAIL';
export const UPDATE_TOBA = 'UPDATE_TOBA';
export const UPDATE_TOBA_SUCCESS = 'UPDATE_TOBA_SUCCESS';
export const UPDATE_TOBA_FAIL = 'UPDATE_TOBA_FAIL';
export const CLOSE_TOBA_REVISION_MODAL = 'CLOSE_TOBA_REVISION_MODAL';
export const OPEN_TOBA_REVISION_MODAL = 'OPEN_TOBA_REVISION_MODAL';
export const POPULATE_TOBA_FORM_FROM_REVISION = 'POPULATE_TOBA_FORM_FROM_REVISION';
export const GET_TOBA_REVISIONS = 'GET_TOBA_REVISIONS';
export const GET_TOBA_REVISIONS_SUCCESS = 'GET_TOBA_REVISIONS_SUCCESS';
export const GET_TOBA_REVISIONS_FAIL = 'GET_TOBA_REVISIONS_FAIL';
export const REMOVE_FETCHED_TOBA_ATTACHMENT = 'REMOVE_FETCHED_TOBA_ATTACHMENT';
export const ADD_TOBA_FORM_ATTACHMENT = 'ADD_TOBA_FORM_ATTACHMENT';
export const REMOVE_TOBA_FORM_ATTACHMENT = 'REMOVE_TOBA_FORM_ATTACHMENT';
export const OPEN_TOBA_REJECT_MODAL = 'OPEN_TOBA_REJECT_MODAL';
export const CLOSE_TOBA_REJECT_MODAL = 'CLOSE_TOBA_REJECT_MODAL';
//TOBA LIST
export const TOBAS_LIST_PAGE_SHIFT = 'TOBAS_LIST_PAGE_SHIFT';
export const CHANGE_TOBA_LIST_STORE_SETTINGS = 'CHANGE_TOBA_LIST_STORE_SETTINGS';
//TOBAS
export const GET_TOBA_BY_ID = 'GET_TOBA_BY_ID';
export const RECEIVE_TOBA_BY_ID = 'RECEIVE_TOBA_BY_ID';
export const FAILED_TO_RECEIVE_TOBA_BY_ID = 'FAILED_TO_RECEIVE_TOBA_BY_ID';
export const FAILED_TO_DELETE_TOBA = 'FAILED_TO_DELETE_TOBA';
export const RECEIVE_DELETE_TOBA_RESPONSE = 'RECEIVE_DELETE_TOBA_RESPONSE';
export const DELETE_TOBA = 'DELETE_TOBA';
export const GET_TOBAS = 'GET_TOBAS';
export const RECEIVE_ALL_TOBAS = 'RECEIVE_ALL_TOBAS';
export const FAILED_TO_GET_TOBAS = 'FAILED_TO_GET_TOBAS';
export const GET_VALID_TOBAS = 'GET_VALID_TOBAS';
export const RECEIVE_ALL_VALID_TOBAS = 'RECEIVE_ALL_VALID_TOBAS';
export const FAILED_TO_GET_VALID_TOBAS = 'FAILED_TO_GET_VALID_TOBAS';
//OVERVIEW TAB
export const CHANGE_OVERVIEW_ATTACHMENT = 'CHANGE_OVERVIEW_ATTACHMENT';
export const REMOVE_OVERVIEW_ATTACHMENT = 'REMOVE_OVERVIEW_ATTACHMENT';
export const ADD_ANOTHER_OVERVIEW_ATTACHMENT = 'ADD_ANOTHER_OVERVIEW_ATTACHMENT';
export const GET_OVERVIEW_TAB_TAGS_DESCRIPTION = 'GET_OVERVIEW_TAB_TAGS_DESCRIPTION';
export const GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS = 'GET_OVERVIEW_TAB_TAGS_DESCRIPTION_SUCCESS';
export const GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL = 'GET_OVERVIEW_TAB_TAGS_DESCRIPTION_FAIL';

//UPDATE TAB
export const PREPOPULATE_UPDATE_FORM_FIELD = 'PREPOPULATE_UPDATE_FORM_FIELD';
export const GET_UPDATE_TAB_TAGS_DESCRIPTION = 'GET_UPDATE_TAB_TAGS_DESCRIPTION';
export const GET_UPDATE_TAB_TAGS_DESCRIPTION_SUCCESS = 'GET_UPDATE_TAB_TAGS_DESCRIPTION_SUCCESS';
export const GET_UPDATE_TAB_TAGS_DESCRIPTION_FAIL = 'GET_UPDATE_TAB_TAGS_DESCRIPTION_FAIL';

//NEW USER
export const CHANGE_NEW_USER_NEW_PASSWORD_FORM = 'CHANGE_NEW_USER_NEW_PASSWORD_FORM';
export const CHANGE_NEW_USER_STORE_SETTINGS = 'CHANGE_NEW_USER_STORE_SETTINGS';
export const OPEN_CHANGE_PASSWORD_MODAL = 'OPEN_CHANGE_PASSWORD_MODAL';
export const CLOSE_CHANGE_PASSWORD_MODAL = 'CLOSE_CHANGE_PASSWORD_MODAL';
export const OPEN_DELETE_USER_MODAL = 'OPEN_DELETE_USER_MODAL';
export const CLOSE_DELETE_USER_MODAL = 'CLOSE_DELETE_USER_MODAL';
export const DELETE_ARAG_USER = 'DELETE_ARAG_USER';
export const DELETE_ARAG_USER_SUCCESS = 'DELETE_ARAG_USER_SUCCESS';
export const DELETE_ARAG_USER_FAIL = 'DELETE_ARAG_USER_FAIL';
export const HANDLE_SUB_CASES_PER_CASE_TYPE = 'HANDLE_SUB_CASES_PER_CASE_TYPE';
export const RESET_ARAG_USER_PASSWORD = 'RESET_ARAG_USER_PASSWORD';
export const RESET_ARAG_USER_PASSWORD_SUCCESS = 'RESET_ARAG_USER_PASSWORD_SUCCESS';
export const RESET_ARAG_USER_PASSWORD_FAIL = 'RESET_ARAG_USER_PASSWORD_FAIL';

export const UNLOCK_ARAG_USER = 'UNLOCK_ARAG_USER';
export const UNLOCK_ARAG_USER_SUCCESS = 'UNLOCK_ARAG_USER_SUCCESS';
export const UNLOCK_ARAG_USER_FAILED = 'UNLOCK_ARAG_USER_FAILED';
//USER LIST

export const CHANGE_USER_LIST_STORE_SETTINGS = 'CHANGE_USER_LIST_STORE_SETTINGS';
export const GET_ARAG_USER_BY_ID = 'GET_ARAG_USER_BY_ID';
export const GET_ARAG_USER_BY_ID_SUCCESS = 'GET_ARAG_USER_BY_ID_SUCCESS';
export const GET_ARAG_USER_BY_ID_FAIL = 'GET_ARAG_USER_BY_ID_FAIL';
export const GET_USER_LEVELS = 'GET_USER_LEVELS';
export const GET_USER_LEVELS_SUCCESS = 'GET_USER_LEVELS_SUCCESS';
export const GET_USER_LEVELS_FAIL = 'GET_USER_LEVELS_FAIL';
export const GET_USER_GROUPS = 'GET_USER_GROUPS';
export const GET_USER_GROUPS_SUCCESS = 'GET_USER_GROUPS_SUCCESS';
export const GET_USER_GROUPS_FAIL = 'GET_USER_GROUPS_FAIL';
//ADVANCE DISBURSEMENTS TAB
export const OPEN_AD_MODAL = 'OPEN_AD_MODAL';
export const CLOSE_AD_MODAL = 'CLOSE_AD_MODAL';
export const CHANGE_ADVANCE_DISBURSEMENTS_TAB_STORE_SETTINGS = 'CHANGE_ADVANCE_DISBURSEMENTS_TAB_STORE_SETTINGS';
//ADVANCED DISBURSEMENTS LIST SETTINGS
export const CLEAR_ADVANCE_DISBURSEMENTS_FILTERS = 'CLEAR_ADVANCE_DISBURSEMENTS_FILTERS';
export const ADVANCED_DISBURSEMENTS_LIST_PAGE_SHIFT = 'ADVANCED_DISBURSEMENTS_LIST_PAGE_SHIFT';
export const CHANGE_ADVANCED_DISBURSEMENTS_LIST_SETTINGS = 'CHANGE_ADVANCED_DISBURSEMENTS_LIST_SETTINGS';
//ADVANCED DISBURSEMENTS
export const GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES = 'GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES';
export const GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_SUCCESS = 'GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_SUCCESS';
export const GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_FAILED = 'GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_FAILED';
export const GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT = 'GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT';
export const GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_SUCCESS = 'GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_SUCCESS';
export const GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_FAILED = 'GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_FAILED';
export const GET_APPLICATION_AD_UPDATE_STATUS = 'GET_APPLICATION_AD_UPDATE_STATUS';
export const GET_APPLICATION_AD_UPDATE_STATUS_SUCCESS = 'GET_APPLICATION_AD_UPDATE_STATUS_SUCCESS';
export const GET_APPLICATION_AD_UPDATE_STATUS_FAIL = 'GET_APPLICATION_AD_UPDATE_STATUS_FAIL';
export const GET_ADVANCE_DISBURSEMENTS_STATUSES = 'GET_ADVANCE_DISBURSEMENTS_STATUSES';
export const GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS = 'GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS';
export const RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES = 'RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES';
export const FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES = 'FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES';
export const RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS = 'RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS';
export const FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS = 'FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS';
export const EDIT_ADVANCE_DISBURSEMENT = 'EDIT_ADVANCE_DISBURSEMENT';
export const RECEIVE_EDIT_ADVANCE_DISBURSEMENT = 'RECEIVE_EDIT_ADVANCE_DISBURSEMENT';
export const FAILED_TO_EDIT_ADVANCE_DISBURSEMENT = 'FAILED_TO_EDIT_ADVANCE_DISBURSEMENT';
export const GET_ADVANCE_DISBURSEMENT_BY_ID = 'GET_ADVANCE_DISBURSEMENT_BY_ID';
export const RECEIVE_ADVANCE_DISBURSEMENT_BY_ID = 'RECEIVE_ADVANCE_DISBURSEMENT_BY_ID';
export const FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENT_BY_ID = 'FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENT_BY_ID';
export const CREATE_ADVANCED_DISBURSEMENT = 'CREATE_ADVANCED_DISBURSEMENT';
export const RECEIVE_CREATE_ADVANCED_DISBURSEMENT = 'RECEIVE_CREATE_ADVANCED_DISBURSEMENT';
export const FAILED_TO_CREATE_ADVANCED_DISBURSEMENT = 'FAILED_TO_CREATE_ADVANCED_DISBURSEMENT';
export const GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY = 'GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY';
export const RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY = 'RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY';
export const FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY = 'FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY';
export const GET_ALL_ADVANCED_DISBURSEMENTS = 'GET_ALL_ADVANCED_DISBURSEMENTS';
export const RECEIVE_ALL_ADVANCED_DISBURSEMENTS = 'RECEIVE_ALL_ADVANCED_DISBURSEMENTS';
export const FAILED_TO_RECEIVE_ALL_ADVANCED_DISBURSEMENTS = 'FAILED_TO_RECEIVE_ALL_ADVANCED_DISBURSEMENTS';
export const GET_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS = 'GET_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS';
export const RECEIVE_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS = 'RECEIVE_ALL_ADVANCED_DISBURSEMENTS_SUGGESTIONS';
export const FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_SUGGESTIONS = 'FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_SUGGESTIONS';
export const CHANGE_ADVANCE_DISBURSEMENTS_STORE_SETTINGS = 'CHANGE_ADVANCE_DISBURSEMENTS_STORE_SETTINGS';
//ADVANCED DISBURSEMENTS FORM
export const CHANGE_AD_FORM_DATA = 'CHANGE_AD_FORM_DATA';
export const CHANGE_AD_FORM_SETTINGS = 'CHANGE_AD_FORM_SETTINGS';
export const ADD_AD_ATTACHMENT = 'ADD_AD_ATTACHMENT';
export const REMOVE_AD_FORM_ATTACHMENT = 'REMOVE_AD_FORM_ATTACHMENT';

//EXPENSE TYPES
export const GET_EXPENSE_TYPES = 'GET_EXPENSE_TYPES';
export const RECEIVE_EXPENSE_TYPES = 'RECEIVE_EXPENSE_TYPES';
export const FAILED_TO_RECEIVE_EXPENSE_TYPES = 'FAILED_TO_RECEIVE_EXPENSE_TYPES';
//Action Types of user
export const SEND_FORGOT_PASSWORD = 'SEND_FORGOT_PASSWORD';
export const SEND_FORGOT_PASSWORD_SUCCESS = 'SEND_FORGOT_PASSWORD_SUCCESS';
export const SEND_FORGOT_PASSWORD_FAILED = 'SEND_FORGOT_PASSWORD_FAILED';
export const GET_SESSION_EXPIRATION_DATE = 'GET_SESSION_EXPIRATION_DATE';
export const GET_SESSION_EXPIRATION_DATE_SUCCESS = 'GET_SESSION_EXPIRATION_DATE_SUCCESS';
export const GET_SESSION_EXPIRATION_DATE_FAIL = 'GET_SESSION_EXPIRATION_DATE_FAIL';
export const CHANGE_USER_AT_LOGIN_PROPERTIES = 'CHANGE_USER_AT_LOGIN_PROPERTIES';
export const DISPLAY_INFO_DIALOG_BOX = 'DISPLAY_INFO_DIALOG_BOX';
export const DISPLAY_REJECT_AUTH_DIALOG_BOX = 'DISPLAY_REJECT_AUTH_DIAL';
export const REQUEST_TO_LOGIN = 'REQUEST_TO_LOGIN';
export const RECEIVE_LOG_IN_RESPONSE = 'RECEIVE_LOG_IN_RESPONSE';
export const CHANGE_USER_STATE_SETTINGS = 'CHANGE_USER_STATE_SETTINGS';
export const RECEIVE_VERSION = 'RECEIVE_VERSION';

export const UNLOCK_SOLICITOR_USER = 'UNLOCK_SOLICITOR_USER';
export const UNLOCK_SOLICITOR_USER_SUCCESS = 'UNLOCK_SOLICITOR_USER_SUCCESS';
export const UNLOCK_SOLICITOR_USER_FAILED = 'UNLOCK_SOLICITOR_USER_FAILED';

export const SOLICITOR_FORM_EMAIL_INFO = 'SOLICITOR_FORM_EMAIL_INFO';
export const SOLICITOR_FORM_USERNAME_INFO = 'SOLICITOR_FORM_USERNAME_INFO';
export const SOLICITOR_FORM_EMAIL_VALIDATION_ERROR = 'SOLICITOR_FORM_EMAIL_VALIDATION_ERROR';
export const SOLICITOR_FORM_USERNAME_VALIDATION_ERROR = 'SOLICITOR_FORM_USERNAME_VALIDATION_ERROR';
export const CHANGE_NEW_SOLICITOR_PROPERTIES = 'CHANGE_NEW_SOLICITOR_PROPERTIES';
export const CHECK_SOLICITOR_USER = 'CHECK_SOLICITOR_USER';
export const GET_SOLICITOR_USER_COLLEAGUES = 'GET_SOLICITOR_USER_COLLEAGUES';
export const GET_SOLICITOR_USER_COLLEAGUES_SUCCESS = 'GET_SOLICITOR_USER_COLLEAGUES_SUCCESS';
export const GET_SOLICITOR_USER_COLLEAGUES_FAILED = 'GET_SOLICITOR_USER_COLLEAGUES_FAILED';
export const SORT_AGENTS_LIST = 'SORT_AGENTS_LIST';
export const CHANGE_SOLICITOR_DISPLAYED_USERS = 'CHANGE_SOLICITOR_DISPLAYED_USERS';
export const CHECK_ALL_SOLICITOR_USERS = 'CHECK_ALL_SOLICITOR_USERS';
export const CHANGE_SOLICITOR_USERS_LIST_SETTINGS = 'CHANGE_SOLICITOR_USERS_LIST_SETTINGS';
export const SOLICITOR_USERS_PAGE_SHIFT = 'SOLICITOR_USERS_PAGE_SHIFT';
export const SOLICITOR_USERS_AGENTS_FILTER = 'SOLICITOR_USERS_AGENTS_FILTER';
export const LOGOUT = 'LOGOUT';

export const CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY = 'CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY';
export const CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_SUCCESS = 'CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_SUCCESS';
export const CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_FAILED = 'CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_FAILED';

export const REQUEST_LAWSYS_FIRMS = 'REQUEST_LAWSYS_FIRMS';
export const REQUEST_LAWSYS_FIRMS_FILTERED = 'REQUEST_LAWSYS_FIRMS_FILTERED';
export const REQUEST_LAWSYS_FIRMS_WITH_AGENTS = 'REQUEST_LAWSYS_FIRMS_WITH_AGENTS';
export const RECEIVE_LAWSYS_FIRMS = 'RECEIVE_LAWSYS_FIRMS';
export const RECEIVE_LAWSYS_FIRMS_FILTERED = 'RECEIVE_LAWSYS_FIRMS_FILTERED';
export const RECEIVE_LAWSYS_FIRMS_WITH_AGENTS = 'RECEIVE_LAWSYS_FIRMS_WITH_AGENTS';
export const REQUEST_LAWSYS_FIRM_GROUP = 'REQUEST_LAWSYS_FIRM_GROUP';
export const RECEIVE_LAWSYS_FIRM_GROUP = 'RECEIVE_LAWSYS_FIRM_GROUP';
export const REQUEST_BROKER_FIRMS_FILTERED = 'REQUEST_BROKER_FIRMS_FILTERED';
export const RECEIVE_BROKER_FIRMS_FILTERED = 'RECEIVE_BROKER_FIRMS_FILTERED';
export const FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP = 'FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP';
export const REQUEST_NEW_SOLICITOR = 'REQUEST_NEW_SOLICITOR';
export const RECEIVE_POST_NEW_SOLICITOR_RESPONSE = 'RECEIVE_POST_NEW_SOLICITOR_RESPONSE';
export const CHANGE_SELECTED_SOLICITOR_USERS = 'CHANGE_SELECTED_SOLICITOR_USERS';
export const REQUEST_UPDATE_CHECKED_SOLICITORS = 'REQUEST_UPDATE_CHECKED_SOLICITORS';
export const RECEIVE_UPDATE_CHECKED_SOLICITORS = 'RECEIVE_UPDATE_CHECKED_SOLICITORS';
export const REQUEST_GET_SOLICITORS = 'REQUEST_GET_SOLICITORS';
export const RECEIVE_GET_SOLICITORS = 'RECEIVE_GET_SOLICITORS';
//Get suggestions for Solicitor Users list
export const REQUEST_GET_SOLICITORS_SUGGESTIONS = 'REQUEST_GET_SOLICITORS_SUGGESTIONS';
export const RECEIVE_GET_SOLICITORS_SUGGESTIONS = 'RECEIVE_GET_SOLICITORS_SUGGESTIONS';
export const RECEIVE_BAD_RESPONSE_GET_SOLICITORS_SUGGESTIONS = 'RECEIVE_BAD_RESPONSE_GET_SOLICITORS_SUGGESTIONS';
export const GET_APPLICATION_POLICY_AFTER_AD_CREATE = 'GET_APPLICATION_POLICY_AFTER_AD_CREATE';
export const FILTER_BY_LAWSYS = 'FILTER_BY_LAWSYS';
export const RECEIVE_TOBA = 'RECEIVE_TOBA';
export const FAILED_TO_RECEIVE_TOBA = 'FAILED_TO_RECEIVE_TOBA';
export const REQUEST_TOBA = 'REQUEST_TOBA';
export const REQUEST_ACCEPT_TOBA = 'REQUEST_ACCEPT_TOBA';
export const RECEIVE_ACCEPT_TOBA = 'RECEIVE_ACCEPT_TOBA';
export const FAILED_TO_ACCEPT_TOBA = 'FAILED_TO_ACCEPT_TOBA';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const CHANGE_LAWSYS_ID = 'CHANGE_LAWSYS_ID';
export const DISPLAY_TOBA = 'DISPLAY_TOBA';
export const TOGGLE_CONFIRM_DIALOG = 'TOGGLE_CONFIRM_DIALOG';
export const CHANGE_FORM_DATA = 'CHANGE_FORM_DATA';
export const REQUEST_GET_LAWSYS_DETAILS = 'REQUEST_GET_LAWSYS_DETAILS';
export const RECEIVE_GET_LAWSYS_DETAILS = 'RECEIVE_GET_LAWSYS_DETAILS';
export const RECEIVE_FAILED_RESPONSE_GET_LAWSYS_DETAILS = 'RECEIVE_FAILED_RESPONSE_GET_LAWSYS_DETAILS';
export const REQUEST_GET_SOLICITOR_DETAILS = 'REQUEST_GET_SOLICITOR_DETAILS';
export const RECEIVE_GET_SOLICITOR_DETAILS = 'RECEIVE_GET_SOLICITOR_DETAILS';
export const RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS = 'RECEIVE_FAILED_RESPONSE_GET_SOLICITOR_DETAILS';
export const REQUEST_UPDATE_SOLICITOR_DETAILS = 'REQUEST_UPDATE_SOLICITOR_DETAILS';
export const RECEIVE_UPDATE_SOLICITOR_RESPONSE = 'RECEIVE_UPDATE_SOLICITOR_RESPONSE';
export const TOGGLE_ERROR = 'TOGGLE_ERROR';
export const CHANGE_REFER_TO_BY_CASE_TYPE = 'CHANGE_REFER_TO_BY_CASE_TYPE';
export const CHANGE_REFER_TO_BY_SUB_CASE_TYPE = 'CHANGE_REFER_TO_BY_SUB_CASE_TYPE';
export const REQUEST_GET_SOLICITORS_SOLICITOR_GROUP = 'REQUEST_GET_SOLICITORS_SOLICITOR_GROUP';
export const RECEIVE_GET_SOLICITORS_SOLICITOR_GROUP = 'RECEIVE_GET_SOLICITORS_SOLICITOR_GROUP';
export const REQUEST_GET_UNDERWRITERS = 'REQUEST_GET_UNDERWRITERS';
export const RECEIVE_GET_UNDERWRITERS = 'RECEIVE_GET_UNDERWRITERS';
export const REQUEST_GET_WORK_SOURCES = 'REQUEST_GET_WORK_SOURCES';
export const RECEIVE_GET_WORK_SOURCES = 'RECEIVE_GET_WORK_SOURCES';
export const CHANGE_SOLICITOR_GROUP_FIELD = 'CHANGE_SOLICITOR_GROUP_FIELD';
export const REQUEST_POST_SOLICITOR_GROUP = 'REQUEST_POST_SOLICITOR_GROUP'
export const RECEIVE_POST_SOLICITOR_GROUP_RESPONSES = 'RECEIVE_POST_SOLICITOR_GROUP_RESPONSES';
export const CREATED_SOLICITOR_GROUP_RESPONSE = 'CREATED_SOLICITOR_GROUP_RESPONSE';
export const BAD_REQUEST_POST_SOLICITOR_GROUP = 'BAD_REQUEST_POST_SOLICITOR_GROUP';
export const REQUEST_GET_SOLICITOR_GROUPS = 'REQUEST_GET_SOLICITOR_GROUPS';
export const RECEIVE_SOLICITOR_GROUPS = 'RECEIVE_SOLICITOR_GROUPS';
export const FAILED_TO_GET_SOLICITOR_GROUPS = 'FAILED_TO_GET_SOLICITOR_GROUPS';
export const REQUEST_GET_SOLICITOR_GROUPS_SUGGESTIONS = 'REQUEST_GET_SOLICITOR_GROUPS_SUGGESTIONS';
export const RECEIVE_SOLICITOR_GROUPS_SUGGESTIONS = 'RECEIVE_SOLICITOR_GROUPS_SUGGESTIONS';
export const RECEIVE_BAD_REQUEST_SOLICITOR_GROUPS_SUGGESTIONS = 'RECEIVE_BAD_REQUEST_SOLICITOR_GROUPS_SUGGESTIONS';
export const REQUEST_PATCH_SOLICITOR_GROUP = 'REQUEST_PATCH_SOLICITOR_GROUP';
export const RECEIVE_PATCH_SOLICITOR_GROUP = 'RECEIVE_PATCH_SOLICITOR_GROUP';
export const FAILED_TO_PATCH_SOLICITOR_GROUP = 'FAILED_TO_PATCH_SOLICITOR_GROUP';
export const OPEN_CASE_REFERRAL_KEYWORD_ADDITION_MODAL = 'OPEN_CASE_REFERRAL_KEYWORD_ADDITION_MODAL';
export const GET_CASE_REFERRAL_KEYWORDS = 'GET_CASE_REFERRAL_KEYWORDS';
export const GET_CASE_REFERRAL_KEYWORDS_SUCCESS = 'GET_CASE_REFERRAL_KEYWORDS_SUCCESS';
export const GET_CASE_REFERRAL_KEYWORDS_FAIL = 'GET_CASE_REFERRAL_KEYWORDS_FAIL';
export const CREATE_CASE_REFERRAL_KEYWORD_AND_ADD_ANOTHER = 'CREATE_CASE_REFERRAL_KEYWORD_AND_ADD_ANOTHER';
export const CREATE_CASE_REFERRAL_KEYWORD = 'CREATE_CASE_REFERRAL_KEYWORD';
export const CREATE_CASE_REFERRAL_KEYWORD_SUCCESS = 'CREATE_CASE_REFERRAL_KEYWORD_SUCCESS';
export const CREATE_CASE_REFERRAL_KEYWORD_FAIL = 'CREATE_CASE_REFERRAL_KEYWORD_FAIL';
export const CHANGE_KEYWORD_ADDITION_FORM_REFFERER = 'CHANGE_KEYWORD_ADDITION_FORM_REFFERER';
export const CHANGE_KEYWORD_ADDITION_FORM = 'CHANGE_KEYWORD_ADDITION_FORM';
export const CLOSE_CASE_REFERRAL_KEYWORD_ADDITION_MODAL = 'CLOSE_CASE_REFERRAL_KEYWORD_ADDITION_MODAL';
export const CHANGE_REFERRAL_SETTINGS_STATE = 'CHANGE_REFERRAL_SETTINGS_STATE';
export const REQUEST_FILTERED_POLICY = 'REQUEST_FILTERED_POLICY';
export const REQUEST_APPLICATION_FORM_TEMPLATE = 'REQUEST_APPLICATION_FORM_TEMPLATE';
export const RECEIVE_FILTERED_POLICY = 'RECEIVE_FILTERED_POLICY';
export const RECEIVE_APPLICATION_FORM_TEMPLATE = 'RECEIVE_APPLICATION_FORM_TEMPLATE';
export const FAILED_TO_RECEIVE_FILTERED_POLICY = 'FAILED_TO_RECEIVE_FILTERED_POLICY';
export const REQUEST_GET_POLICIES = 'REQUEST_GET_POLICIES';
export const RECEIVE_GET_POLICIES = 'RECEIVE_GET_POLICIES';
export const REQUEST_GET_QUESTIONS = 'REQUEST_GET_QUESTIONS';
export const RECEIVE_GET_QUESTIONS = 'RECEIVE_GET_QUESTIONS';
export const REQUEST_GET_CASE_TYPES = 'REQUEST_GET_CASE_TYPES';
export const RECEIVE_GET_CASE_TYPES = 'RECEIVE_GET_CASE_TYPES';
export const CHANGE_FIELD = 'CHANGE_FIELD';
export const RECEIVE_SUB_CASE_TYPES = 'RECEIVE_SUB_CASE_TYPES';
export const CHANGE_SELECTED_QUESTIONS = 'CHANGE_SELECTED_QUESTIONS';
export const REQUEST_POST_POLICY = 'REQUEST_POST_POLICY';
export const RECEIVE_POST_POLICY_RESPONSE = 'RECEIVE_POST_POLICY_RESPONSE';
export const RECEIVE_BAD_REQUEST_POST_POLICY_RESPONSE = 'RECEIVE_BAD_REQUEST_POST_POLICY_RESPONSE';
export const CHANGE_QUESTION_TRIGGER = 'CHANGE_QUESTION_TRIGGER';
export const CHANGE_REFERRAL_TRIGGER = 'CHANGE_REFERRAL_TRIGGER';
export const REQUEST_GET_APPLICATION = 'REQUEST_GET_APPLICATION';
export const RECEIVE_GET_APPLICATION = 'RECEIVE_GET_APPLICATION';
export const CHANGE_NEW_APPLICATION_FIELD = 'CHANGE_NEW_APPLICATION_FIELD';
export const CHANGE_NEW_APPLICATION_FORM_DATA = 'CHANGE_NEW_APPLICATION_FORM_DATA';
export const REQUEST_POST_NEW_APPLICATION = 'REQUEST_POST_NEW_APPLICATION';
export const RECEIVE_POST_NEW_APPLICATION = 'RECEIVE_POST_NEW_APPLICATION';
export const RECEIVE_BAD_REQUEST_POST_NEW_APP = 'RECEIVE_BAD_REQUEST_POST_NEW_APP';
export const UPDATE_EXTRA_OPPONENTS = 'UPDATE_EXTRA_OPPONENTS';
export const RECEIVE_BAD_REQUEST_GET_APPLICATION = 'RECEIVE_BAD_REQUEST_GET_APPLICATION';
export const CLEAR_APPLICATIONS_AND_POLICIES_FILTERS = 'CLEAR_APPLICATIONS_AND_POLICIES_FILTERS';
export const REQUEST_GET_ALL_APPLICATIONS = 'REQUEST_GET_ALL_APPLICATIONS';
export const RECEIVE_GET_ALL_APPLICATIONS = 'RECEIVE_GET_ALL_APPLICATIONS ';
export const REQUEST_GET_ALL_APPLICATIONS_SUGGESTIONS = 'REQUEST_GET_ALL_APPLICATIONS_SUGGESTIONS';
export const RECEIVE_GET_ALL_APPLICATIONS_SUGGESTIONS = 'RECEIVE_GET_ALL_APPLICATIONS_SUGGESTIONS ';
export const RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS_SUGGESTIONS = 'RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS_SUGGESTIONS ';
export const CHANGE_APPLICATION_AND_POLICIES_FIELD = 'CHANGE_APPLICATION_AND_POLICIES_FIELD';
export const PAGE_SHIFT = 'PAGE_SHIFT';
export const RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR = 'RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR';
export const RECEIVE_BAD_RESPONSE_POST_NEW_SOLICITOR = 'RECEIVE_BAD_RESPONSE_POST_NEW_SOLICITOR';
export const REQUEST_PATCH_APPLICATION = 'REQUEST_PATCH_APPLICATION';
export const RECEIVE_PATCH_APPLICATION = 'RECEIVE_PATCH_APPLICATION';
export const RECEIVE_BAD_REQUEST_PATCH_APPLICATION = 'RECEIVE_BAD_REQUEST_PATCH_APPLICATION';
export const RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS = 'RECEIVE_BAD_RESPONSE_GET_ALL_APPLICATIONS';
export const RECEIVE_BAD_REQUEST_GET_SOLICITORS = 'RECEIVE_BAD_REQUEST_GET_SOLICITORS';
export const CHANGE_ACTIVE_TAB = 'CHANGE_ACTIVE_TAB';
export const REQUEST_GET_SELECTED_APPLICATION = 'REQUEST_GET_SELECTED_APPLICATION';
export const RECEIVE_GET_SELECTED_APPLICATION = 'RECEIVE_GET_SELECTED_APPLICATION';
export const REQUEST_GET_ACCEPTED_TOBA = 'REQUEST_GET_ACCEPTED_TOBA';
export const RECEIVE_GET_ACCEPTED_TOBA = 'RECEIVE_GET_ACCEPTED_TOBA';
export const REQUEST_GET_ACCEPTED_TOBA_FAIL = 'REQUEST_GET_ACCEPTED_TOBA_FAIL';
export const REQUEST_DELETE_DRAFTED_APPLICATION = 'REQUEST_DELETE_DRAFTED_APPLICATION';
export const RECEIVE_DELETE_DRAFTED_APPLICATION_RESPONSE = 'RECEIVE_DELETE_DRAFTED_APPLICATION_RESPONSE';
export const RECEIVE_BAD_REQUEST_GET_QUESTIONS = 'RECEIVE_BAD_REQUEST_GET_QUESTIONS';
export const CHANGE_NEW_USER_PROPERTIES = 'CHANGE_NEW_USER_PROPERTIES';
export const REQUEST_NEW_USER = 'REQUEST_NEW_USER';
export const RECEIVE_POST_NEW_USER_RESPONSE = 'RECEIVE_POST_NEW_USER_RESPONSE';
export const RECEIVE_BAD_RESPONSE_POST_NEW_USER = 'RECEIVE_BAD_RESPONSE_POST_NEW_USER';
export const CLEAR_NEW_USER = 'CLEAR_NEW_USER';
export const CHANGE_DISPLAYED_USERS = 'CHANGE_DISPLAYED_USERS';
export const CHANGE_USERS_LIST_SETTINGS = 'CHANGE_USERS_LIST_SETTINGS';
export const USERS_PAGE_SHIFT = 'USERS_PAGE_SHIFT';
export const RECEIVE_GET_USERS = 'RECEIVE_GET_USERS';
export const REQUEST_GET_USERS = 'REQUEST_GET_USERS';
export const RECEIVE_BAD_REQUEST_GET_USERS = 'RECEIVE_BAD_REQUEST_GET_USERS';
export const EDIT_USER = 'EDIT_USER';
export const REQUEST_EDIT_USER = 'REQUEST_EDIT_USER';
export const RECEIVE_PATCH_USER_RESPONSE = 'RECEIVE_PATCH_USER_RESPONSE';
export const RECEIVE_BAD_RESPONSE_PATCH_USER = 'RECEIVE_BAD_RESPONSE_PATCH_USER';
export const ATTACHMENTS_CHANGE = 'ATTACHMENTS_CHANGE';
export const CHANGE_NEW_SOL_FORM_SETTINGS = 'CHANGE_NEW_SOL_FORM_SETTINGS';
export const CHANGE_MANAGE_SOL_ACCOUNT_SETTINGS = 'CHANGE_MANAGE_SOL_ACCOUNT_SETTINGS';
export const RECEIVE_BAD_REQUEST_GET_SELECTED_APPLICATION = 'RECEIVE_BAD_REQUEST_GET_SELECTED_APPLICATION';
export const REQUEST_GET_UPDATE_QUESTIONS = 'REQUEST_GET_UPDATE_QUESTIONS';
export const RECEIVE_GET_UPDATE_QUESTIONS = 'RECEIVE_GET_UPDATE_QUESTIONS';
export const FAILED_TO_RECEIVE_UPDATE_QUESTIONS = 'FAILED_TO_RECEIVE_UPDATE_QUESTIONS';
export const CHANGE_UPDATE_POLICY_FIELD = 'CHANGE_UPDATE_POLICY_FIELD';
export const CHANGE_UPDATE_POLICY_FORM_DATA = 'CHANGE_UPDATE_POLICY_FORM_DATA';
export const REQUEST_POST_UPDATE_POLICY_FORM = 'REQUEST_POST_UPDATE_POLICY_FORM';
export const RECEIVE_POST_UPDATE_POLICY_FORM = 'RECEIVE_POST_UPDATE_POLICY_FORM';
export const RECEIVE_BAD_REQUEST_POST_UPDATE_POLICY_FORM = 'RECEIVE_BAD_REQUEST_POST_UPDATE_POLICY_FORM';
export const UPDATE_POLICY_ATTACHMENTS_CHANGE = 'UPDATE_POLICY_ATTACHMENTS_CHANGE';
export const REQUEST_GET_LAST_UPDATE_POLICY_FORM = 'REQUEST_GET_LAST_UPDATE_POLICY_FORM';
export const RECEIVE_GET_REQUEST_LAST_UPDATE_POLICY_FORM = 'RECEIVE_GET_REQUEST_LAST_UPDATE_POLICY_FORM';
export const FAILED_TO_RECEIVE_LAST_UPDATE_POLICY_FORM = 'FAILED_TO_RECEIVE_LAST_UPDATE_POLICY_FORM';
export const CHANGE_OVERVIEW_POLICY_FIELD = 'CHANGE_OVERVIEW_POLICY_FIELD';
export const REQUEST_POST_OVERVIEW_POLICY_FORM = 'REQUEST_POST_OVERVIEW_POLICY_FORM';
export const RECEIVE_POST_OVERVIEW_POLICY_FORM = 'RECEIVE_POST_OVERVIEW_POLICY_FORM';
export const RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM = 'RECEIVE_BAD_REQUEST_POST_OVERVIEW_POLICY_FORM';
export const OVERVIEW_POLICY_ATTACHMENTS_CHANGE = 'OVERVIEW_POLICY_ATTACHMENTS_CHANGE';
export const REQUEST_GET_APPLICATION_OVERVIEW = 'REQUEST_GET_APPLICATION_OVERVIEW';
export const RECEIVE_GET_APPLICATION_OVERVIEW = 'RECEIVE_GET_APPLICATION_OVERVIEW';
export const RECEIVE_GET_APPLICATION_READ_BY_ARAG = 'RECEIVE_GET_APPLICATION_READ_BY_ARAG';
export const FAILED_TO_GET_APPLICATION_OVERVIEW = 'FAILED_TO_GET_APPLICATION_OVERVIEW'
export const CHANGE_OVERVIEW_TAB_READ_MORE_STATE = 'CHANGE_OVERVIEW_TAB_READ_MORE_STATE';
export const OVERVIEW_TAB_PAGE_SHIFT = 'OVERVIEW_TAB_PAGE_SHIFT';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const REQUEST_PATCH_EXISTING_SOLICITOR = 'REQUEST_PATCH_EXISTING_SOLICITOR';
export const RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE = 'RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE';
export const RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR = 'RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR';
export const REQUEST_GET_SUB_CASE_TYPE = 'REQUEST_GET_SUB_CASE_TYPE';
export const RECEIVE_SUB_CASE_TYPES_SELECTED_APP = 'RECEIVE_SUB_CASE_TYPES_SELECTED_APP';
export const ATTACHMENT_REMOVE = 'ATTACHMENT_REMOVE';
export const REQUEST_GET_ALL_PREVIOUS_UPDATES = 'REQUEST_GET_ALL_PREVIOUS_UPDATES';
export const RECEIVE_GET_ALL_PREVIOUS_UPDATES = 'RECEIVE_GET_ALL_PREVIOUS_UPDATES';
export const FAILED_TO_RECEIVE_ALL_PREVIOUS_UPDATES = 'FAILED_TO_RECEIVE_ALL_PREVIOUS_UPDATES';
export const REMOVE_EXTRA_OPPONENT = 'REMOVE_EXTRA_OPPONENT';
export const REQUEST_DELETE_DOCUMENT = 'REQUEST_DELETE_DOCUMENT';
export const RECEIVE_DELETE_DOCUMENT_RESPONSE = 'RECEIVE_DELETE_DOCUMENT_RESPONSE';
export const RECEIVE_BAD_REQUEST_DELETE_DOCUMENT = 'RECEIVE_BAD_REQUEST_DELETE_DOCUMENT';
export const CHECK_USER_OVERVIEW_TAB_CHECKBOX = 'CHECK_USER_OVERVIEW_TAB_CHECKBOX';
export const REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM = 'REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM';
export const RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM = 'RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM';
export const RECEIVE_BAD_REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM = 'RECEIVE_BAD_REQUEST_POST_NO_CHANGES_UPDATE_POLICY_FORM';
export const REMOVE_NEW_APPLICATION_ATTACHMENT = 'REMOVE_NEW_APPLICATION_ATTACHMENT';
export const REQUEST_GET_ALL_NOTIFICATIONS = 'REQUEST_GET_ALL_NOTIFICATIONS';
export const RECEIVE_GET_ALL_NOTIFICATIONS = 'RECEIVE_GET_ALL_NOTIFICATIONS';
export const RECEIVE_BAD_REQUEST_GET_ALL_NOTIFICATIONS = 'RECEIVE_BAD_REQUEST_GET_ALL_NOTIFICATIONS';
export const CLEAR_ERROR_NOTIFICATIONS = 'CLEAR_ERROR_NOTIFICATIONS';
export const NOTIFICATIONS_PAGE_SHIFT = 'NOTIFICATIONS_PAGE_SHIFT';
export const CHANGE_NOTIFICATIONS_FIELD = 'CHANGE_NOTIFICATIONS_FIELD';
export const REQUEST_PATCH_NOTIFICATION = 'REQUEST_PATCH_NOTIFICATION';
export const RECEIVE_PATCH_NOTIFICATION = 'RECEIVE_PATCH_NOTIFICATION';
export const RECEIVE_BAD_REQUEST_PATCH_NOTIFICATION = 'RECEIVE_BAD_REQUEST_PATCH_NOTIFICATION';
export const SELECT_ACTIVE_TAB_NOTIFICATION = 'SELECT_ACTIVE_TAB_NOTIFICATION';
export const CHANGE_APPLICATION_POLICY_SETTINGS = 'CHANGE_APPLICATION_POLICY_SETTINGS';
export const TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS =  'TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS';
export const REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS =  'REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS';
export const RECEIVE_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS =  'RECEIVE_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS';
export const RECEIVE_BAD_REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS =  'RECEIVE_BAD_REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS';
//PREMIUM SETTINGS ACTIONS
export const RECEIVE_BAD_REQUEST_PREMIUM_SETTING_BY_ID = 'RECEIVE_BAD_REQUEST_PREMIUM_SETTING_BY_ID';
export const GET_ALL_PREMIUM_SETTINGS = 'GET_ALL_PREMIUM_SETTINGS';
export const RECEIVED_ALL_PREMIUM_SETTINGS = 'RECEIVED_ALL_PREMIUM_SETTINGS';
export const FAILED_GET_ALL_PREMIUM_SETTINGS = 'FAILED_GET_ALL_PREMIUM_SETTINGS';
export const UPDATE_DISPLAYED_PREMIUM_SETTINGS = 'UPDATE_DISPLAYED_PREMIUM_SETTINGS';
export const DISPLAY_ONLY_LIVE_PREMIUM_SETTINGS = 'DISPLAY_ONLY_LIVE_PREMIUM_SETTINGS';
export const NEW_PREMIUM_SETTINGS_PROPERTIES = 'NEW_PREMIUM_SETTINGS_PROPERTIES';
export const REQUEST_DELETE_PREMIUM_SETTING = 'REQUEST_DELETE_PREMIUM_SETTING';
export const RECEIVE_DELETE_PREMIUM_SETTING = 'RECEIVE_DELETE_PREMIUM_SETTING';
export const RECEIVE_BAD_REQUEST_DELETE_PREMIUM_SETTING = 'RECEIVE_BAD_REQUEST_DELETE_PREMIUM_SETTING';
export const PREMIUM_SETTINGS_PAGE_SHIFT = 'PREMIUM_SETTINGS_PAGE_SHIFT';
export const PREMIUM_SETTINGS_GO_TO_PAGE = 'PREMIUM_SETTINGS_GO_TO_PAGE';
export const RECEIVE_GET_GROUP_WORK_SOURCES = 'RECEIVE_GET_GROUP_WORK_SOURCES';
export const CHANGE_PS_TYPE = 'CHANGE_PS_TYPE';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CHANGE_SOLICITOR_GROUP = 'CHANGE_SOLICITOR_GROUP';
export const CHANGE_WORKSOURCE = 'CHANGE_WORKSOURCE';
export const RECEIVE_SUB_CASE_TYPES_PREMIUM_SETTINGS = 'RECEIVE_SUB_CASE_TYPES_PREMIUM_SETTINGS';
export const CHANGE_PREMIUM_SETTINGS_FORM_INFO_STATE = 'CHANGE_PREMIUM_SETTINGS_FORM_INFO_STATE';
export const CHANGE_NEW_PREMIUM_STORE_SETTINGS = 'CHANGE_NEW_PREMIUM_STORE_SETTINGS';
export const REQUEST_POST_NEW_PREMIUM_SETTING = 'REQUEST_POST_NEW_PREMIUM_SETTING';
export const RECEIVE_POST_RESPONSE_NEW_PREMIUM_SETTING = 'RECEIVE_POST_RESPONSE_NEW_PREMIUM_SETTING';
export const RECEIVE_BAD_REQUEST_POST_NEW_POLICY_SETTING = 'RECEIVE_BAD_REQUEST_POST_NEW_POLICY_SETTING';
export const NEW_SOLICITOR_UPDATE_LAWSYS_FIELD = 'NEW_SOLICITOR_UPDATE_LAWSYS_FIELD';
export const CHANGE_NEW_TOBA_PROPERTIES = 'CHANGE_NEW_TOBA_PROPERTIES';
export const REQUEST_POST_NEW_TOBA = 'REQUEST_POST_NEW_TOBA';
export const RECEIVE_POST_NEW_TOBA_RESPONSE = 'RECEIVE_POST_NEW_TOBA_RESPONSE';
export const RECEIVE_BAD_RESPONSE_POST_NEW_TOBA = 'RECEIVE_BAD_RESPONSE_POST_NEW_TOBA';
export const CLEAR_NEW_TOBA = 'CLEAR_NEW_TOBA';
export const REQUEST_PREMIUM_SETTINGS_DAMAGES = 'REQUEST_PREMIUM_SETTINGS_DAMAGES';
export const RECEIVE_PREMIUM_SETTINGS_DAMAGES = 'RECEIVE_PREMIUM_SETTINGS_DAMAGES';
export const FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES = 'FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES';
export const REQUEST_PREMIUM_SETTINGS_STAGES = 'REQUEST_PREMIUM_SETTINGS_STAGES';
export const RECEIVE_PREMIUM_SETTINGS_STAGES = 'RECEIVE_PREMIUM_SETTINGS_STAGES';
export const FAILED_TO_GET_PREMIUM_SETTINGS_STAGES = 'FAILED_TO_GET_PREMIUM_SETTINGS_STAGES';
export const REQUEST_PREMIUM_SETTINGS_SCHEDULES = 'REQUEST_PREMIUM_SETTINGS_SCHEDULES';
export const RECEIVE_PREMIUM_SETTINGS_SCHEDULES = 'RECEIVE_PREMIUM_SETTINGS_SCHEDULES';
export const REQUEST_PREMIUM_SETTINGS_SCHEDULE_TYPES = 'REQUEST_PREMIUM_SETTINGS_SCHEDULE_TYPES';
export const RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES = 'RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES';
export const REQUEST_PATCH_PREMIUM_SETTING = 'REQUEST_PATCH_PREMIUM_SETTING';
export const RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING = 'RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING';
export const RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING = 'RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING';
export const GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE = 'GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE';
export const RECEIVED_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP = 'RECEIVED_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP';
export const FAILED_GET_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP = 'FAILED_GET_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP';
export const UPDATE_MEDICAL_EXPERT_FEES = 'UPDATE_MEDICAL_EXPERT_FEES';
export const REQUEST_BREACH_CAUSATION_CP = 'REQUEST_BREACH_CAUSATION_CP';
export const RECEIVE_BREACH_CAUSATION_CP = 'RECEIVE_BREACH_CAUSATION_CP';
export const RECEIVE_BAD_REQUEST_BREACH_CAUSATION_CP = 'RECEIVE_BAD_REQUEST_BREACH_CAUSATION_CP';
export const REQUEST_NEW_APPLICATION_FORM_MESSAGE = 'REQUEST_NEW_APPLICATION_FORM_MESSAGE';
export const RECEIVE_NEW_APPLICATION_FORM_MESSAGE = 'RECEIVE_NEW_APPLICATION_FORM_MESSAGE';
export const GET_PREMIUM_SETTINGS_WITH_COMBINATION ='GET_PREMIUM_SETTINGS_WITH_COMBINATION';
export const RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION = 'RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION';
export const CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION = 'CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION';
export const FAILED_TO_GET_PREMIUM_SETTINGS_WITH_COMBINATION = 'FAILED_TO_GET_PREMIUM_SETTINGS_WITH_COMBINATION';
export const GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION ='GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION';
export const RECEIVE_ALL_PREMIUM_SETTINGS_WITH_COMBINATION = 'RECEIVE_ALL_PREMIUM_SETTINGS_WITH_COMBINATION';
export const FAILED_TO_GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION = 'FAILED_TO_GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION';
export const CHANGE_SOLICITOR_USER_ADVANCE_DISBURSEMENTS='CHANGE_SOLICITOR_USER_ADVANCE_DISBURSEMENTS';
export const CHANGE_LAWSYS_FIRM_STATE='CHANGE_LAWSYS_FIRM_STATE';

//USER SET PASSWORD ACTIONS
export const SET_USER_SET_PASSWORD_SETTINGS = 'SET_USER_SET_PASSWORD_SETTINGS';
export const REQUEST_POST_USER_SET_PASSWORD = 'REQUEST_POST_USER_SET_PASSWORD';
export const RECEIVE_POST_USER_SET_PASSWORD = 'RECEIVE_POST_USER_SET_PASSWORD';
export const RECEIVE_BAD_REQUEST_POST_USER_SET_PASSWORD = 'RECEIVE_BAD_REQUEST_POST_USER_SET_PASSWORD';
//SOLICITOR GROUP LIST SETTINGS
export const CHANGE_SOLICITOR_GROUP_LIST_SETTINGS = 'CHANGE_SOLICITOR_GROUP_LIST_SETTINGS';
export const SOLICITOR_GROUP_PAGE_SHIFT = 'SOLICITOR_GROUP_PAGE_SHIFT';
export const REQUEST_DELETE_SOLICITOR_GROUP = 'REQUEST_DELETE_SOLICITOR_GROUP';
export const RECEIVE_DELETE_SOLICITOR_GROUP = 'RECEIVE_DELETE_SOLICITOR_GROUP';
export const BAD_RESPONSE_DELETE_SOLICITOR_GROUP = 'BAD_RESPONSE_DELETE_SOLICITOR_GROUP';
export const RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP = 'RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP';
export const REQUEST_PATCH_SELECTED_SOLICITOR_GROUP = 'REQUEST_PATCH_SELECTED_SOLICITOR_GROUP';
export const BAD_REQUEST_RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP = 'BAD_REQUEST_RECEIVE_PATCH_SELECTED_SOLICITOR_GROUP';
//APPLICATION POLICY
export const GET_APPLICATION_POLICY_IPID = 'GET_APPLICATION_POLICY_IPID';
export const GET_APPLICATION_POLICY_IPID_SUCCESS = 'GET_APPLICATION_POLICY_IPID_SUCCESS';
export const GET_APPLICATION_POLICY_IPID_FAILED = 'GET_APPLICATION_POLICY_IPID_FAILED';
export const GET_APPLICATION_POLICY_WORDING = 'GET_APPLICATION_POLICY_WORDING';
export const GET_APPLICATION_POLICY_WORDING_SUCCESS = 'GET_APPLICATION_POLICY_WORDING_SUCCESS';
export const GET_APPLICATION_POLICY_WORDING_FAIL = 'GET_APPLICATION_POLICY_WORDING_FAIL';
export const REQUEST_GET_ALL_APPLICATION_ATTACHMENTS = 'REQUEST_GET_ALL_APPLICATION_ATTACHMENTS';
export const RECEIVE_ALL_APPLICATION_ATTACHMENTS = 'RECEIVE_ALL_APPLICATION_ATTACHMENTS';
export const REQUEST_APPLICATION_ATTACHMENT = 'REQUEST_APPLICATION_ATTACHMENT';
export const RECEIVE_APPLICATION_ATTACHMENT = 'RECEIVE_APPLICATION_ATTACHMENT';
export const RECEIVE_BAD_REQUEST_APPLICATION_ATTACHMENT = 'RECEIVE_BAD_REQUEST_APPLICATION_ATTACHMENT';
export const REQUEST_APPLICATION_PREMIUM_SETTINGS = 'REQUEST_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS';
export const REQUEST_POST_APPLICATION_PREMIUM_SETTINGS = 'REQUEST_POST_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_POST_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_POST_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_BAD_REQUEST_POST_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_BAD_REQUEST_POST_APPLICATION_PREMIUM_SETTINGS';
export const REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS = 'REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS';
export const REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS = 'REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_DELETE_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_DELETE_APPLICATION_PREMIUM_SETTINGS';
export const RECEIVE_BAD_REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS = 'RECEIVE_BAD_REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS';
export const CHANGE_APP_PREMIUM_SETTINGS_FIELD = 'CHANGE_APP_PREMIUM_SETTINGS_FIELD';
export const RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM = 'RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM';
export const RECEIVE_BAD_REQUEST_PATCH_APPLICATION_AFTER_PREMIUM_SETTINGS = 'RECEIVE_BAD_REQUEST_PATCH_APPLICATION_AFTER_PREMIUM_SETTINGS';
export const CHANGE_SUB_SETTING_DAMAGES = 'CHANGE_SUB_SETTING_DAMAGES';
export const CHANGE_SUB_SETTING = 'CHANGE_SUB_SETTING';
export const REQUEST_GET_SOLICITOR_GROUP_OF_APPLICATION = 'REQUEST_GET_SOLICITOR_GROUP_OF_APPLICATION';
export const RECEIVE_GET_SOLICITOR_GROUP_OF_APPLICATION = 'RECEIVE_GET_SOLICITOR_GROUP_OF_APPLICATION';
export const FAILED_TO_RECEIVE_SOLICITOR_GROUP_OF_APPLICATION = 'FAILED_TO_RECEIVE_SOLICITOR_GROUP_OF_APPLICATION';
export const CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE = 'CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE';
export const CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR = 'CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR';
export const FAILED_TO_GET_ALL_APPLICATION_ATTACHMENTS =  'FAILED_TO_GET_ALL_APPLICATION_ATTACHMENTS';
//SUBMITTED POLICY
export const GET_POSTED_APPLICATION_MESSAGE = 'GET_POSTED_APPLICATION_MESSAGE';
export const GET_POSTED_APPLICATION_MESSAGE_SUCCESS = 'GET_POSTED_APPLICATION_MESSAGE_SUCCESS';
export const GET_POSTED_APPLICATION_MESSAGE_FAIL = 'GET_POSTED_APPLICATION_MESSAGE_FAIL';
//GROUPS
export const GET_GROUP_EXPENSES_CASE_TYPES = 'GET_GROUP_EXPENSES_CASE_TYPES';
export const RECEIVE_GROUP_EXPENSES_CASE_TYPES = 'RECEIVE_GROUP_EXPENSES_CASE_TYPES';
export const FAILED_TO_RECEIVE_GROUP_EXPENSES_CASE_TYPES = 'FAILED_TO_RECEIVE_GROUP_EXPENSES_CASE_TYPES';
export const CHANGE_SELECTED_TOBA = 'CHANGE_SELECTED_TOBA';
export const CHANGE_AD_EXPENSE_TYPES = 'CHANGE_AD_EXPENSE_TYPES';
export const CHANGE_ADVANCED_DISBURSEMENTS_FORM_DATA = 'CHANGE_ADVANCED_DISBURSEMENTS_FORM_DATA';
export const GET_CASE_TYPES_OF_GROUP_BY_ID = 'GET_CASE_TYPES_OF_GROUP_BY_ID';
export const RECEIVE_CASE_TYPES_OF_GROUP_BY_ID = 'RECEIVE_CASE_TYPES_OF_GROUP_BY_ID';
export const FAILED_TO_RECEIVE_CASE_TYPES_OF_GROUP_BY_ID = 'FAILED_TO_RECEIVE_CASE_TYPES_OF_GROUP_BY_ID';
export const REQUEST_GET_GROUPS_OF_SOLICITORS = 'REQUEST_GET_GROUPS_OF_SOLICITORS';
export const RECEIVE_GROUPS_OF_SOLICITORS = 'RECEIVE_GROUPS_OF_SOLICITORS';
export const FAILED_TO_GET_GROUPS_OF_SOLICITORS = 'FAILED_TO_GET_GROUPS_OF_SOLICITORS';
export const REQUEST_GET_SPECIFIC_SOLICITOR_GROUP = 'REQUEST_GET_SPECIFIC_SOLICITOR_GROUP';
export const RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP = 'RECEIVE_GET_SPECIFIC_SOLICITOR_GROUP';
export const RECEIVE_BAD_REQUEST_GET_SPECIFIC_SOLICITOR_GROUP = 'RECEIVE_BAD_REQUEST_GET_SPECIFIC_SOLICITOR_GROUP';
export const REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP = 'REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP';
export const RECEIVE_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP = 'RECEIVE_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP';
export const RECEIVE_BAD_REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP = 'RECEIVE_BAD_REQUEST_GET_UNDERWRITER_OF_SPECIFIC_SOLICITOR_GROUP';
export const RECEIVE_CASE_TYPE_EDIT = 'RECEIVE_CASE_TYPE_EDIT';
export const GET_SOLICITOR_GROUP_CASE_TYPES = 'GET_SOLICITOR_GROUP_CASE_TYPES';
export const RECEIVE_SOLICITOR_GROUP_CASE_TYPES = 'RECEIVE_SOLICITOR_GROUP_CASE_TYPES';
export const FAILED_TO_RECEIVE_SOLICITOR_GROUP_CASE_TYPES = 'FAILED_TO_RECEIVE_SOLICITOR_GROUP_CASE_TYPES';
export const PATCH_SOLICITOR_GROUP = 'PATCH_SOLICITOR_GROUP';
export const RECEIVE_RESPONSE_PATCH_SELECTED_SOLICITOR_GROUP = 'RECEIVE_RESPONSE_PATCH_SELECTED_SOLICITOR_GROUP';
export const FAILED_PATCH_SOLICITOR_GROUP = 'FAILED_PATCH_SOLICITOR_GROUP';
export const ADD_SOLICITOR_GROUP_UNDERWRITER = 'ADD_SOLICITOR_GROUP_UNDERWRITER';
export const EDIT_SOLICITOR_GROUP_UNDERWRITER = 'EDIT_SOLICITOR_GROUP_UNDERWRITER';
export const REMOVE_SOLICITOR_GROUP_UNDERWRITER = 'REMOVE_SOLICITOR_GROUP_UNDERWRITER';
export const GET_GROUP_QUESTIONS_SPEC = 'GET_GROUP_QUESTIONS_SPEC';
export const GET_GROUP_QUESTIONS_SPEC_SUCCESS = 'GET_GROUP_QUESTIONS_SPEC_SUCCESS';
export const GET_GROUP_QUESTIONS_SPEC_FAILURE = 'GET_GROUP_QUESTIONS_SPEC_FAILURE';
export const GET_GROUP_SPEC_DTO = 'GET_GROUP_SPEC_DTO';
export const GET_GROUP_SPEC_DTO_SUCCESS = 'GET_GROUP_SPEC_DTO_SUCCESS';
export const GET_GROUP_SPEC_DTO_FAILURE = 'GET_GROUP_SPEC_DTO_FAILURE';


//AGENTS_LIST
export const CHANGE_AGENTS_LIST_SETTINGS = 'CHANGE_AGENTS_LIST_SETTINGS';
export const REQUEST_GET_SELECTED_SOLICITOR_USER = 'REQUEST_GET_SELECTED_SOLICITOR_USER';
export const RECEIVE_GET_SELECTED_SOLICITOR_USER = 'RECEIVE_GET_SELECTED_SOLICITOR_USER';
export const RECEIVE_BAD_REQUEST_GET_SELECTED_SOLICITOR_USER = 'RECEIVE_BAD_REQUEST_GET_SELECTED_SOLICITOR_USER';
//CYCLE CHAIN FOR FIRST GETTING DATA REQUIRED AND THEN GET REQUEST SOLICITOR GROUP BY ID
export const REQUEST_GET_SPECIFIC_SOLICITOR_GROUP_EDIT = 'REQUEST_GET_SPECIFIC_SOLICITOR_GROUP_EDIT';
export const RECEIVE_WORK_SOURCES_EDIT = 'RECEIVE_WORK_SOURCES_EDIT';
export const RECEIVE_EXPENSES_EDIT = 'RECEIVE_EXPENSES_EDIT';
export const RECEIVE_UNDERWRITERS_EDIT = 'RECEIVE_UNDERWRITERS_EDIT';
export const RECEIVE_SOLICITOR_EDIT = 'RECEIVE_SOLICITOR_EDIT';
//CYCLE CHAIN FOR FIRST GETTING DATA REQUIRED AND THEN GET REQUEST PREMIUM SETTING BY ID
export const REQUEST_GET_SPECIFIC_PREMIUM_SETTING = 'REQUEST_GET_SPECIFIC_PREMIUM_SETTING';
export const RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN = 'RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN';
export const RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN = 'RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN';
export const RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN = 'RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN'
export const RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES_CHAIN = 'RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES_CHAIN';
export const RECEIVE_PREMIUM_SETTINGS_BY_ID = 'RECEIVE_PREMIUM_SETTINGS_BY_ID';
export const RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN = 'RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN';
export const RECEIVE_PREMIUM_SETTINGS_SUB_CASES_CHAIN = 'RECEIVE_PREMIUM_SETTINGS_SUB_CASES_CHAIN';
//Solicitor get available worksources
export const REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES = 'REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES';
export const RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES = 'RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES';
export const RECEIVE_BAD_REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES = 'RECEIVE_BAD_REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES';
//APPLICATION FORMS AND REFERRAL SETTINGS
export const CHANGE_REF_SETTINGS_INFO_STATE = 'CHANGE_REF_SETTINGS_INFO_STATE';
export const REQUEST_PATCH_POLICY_QUESTIONS_GROUP = 'REQUEST_PATCH_POLICY_QUESTIONS_GROUP';
export const RECEIVE_PATCH_POLICY_QUESTIONS_GROUP = 'RECEIVE_PATCH_POLICY_QUESTIONS_GROUP';
export const FAILED_TO_PATCH_POLICY_QUESTIONS_GROUP = 'FAILED_TO_PATCH_POLICY_QUESTIONS_GROUP';
//TOBA
export const RECEIVE_BAD_REQUEST_NEW_APPLICATION_FORM_MESSAGE = 'RECEIVE_BAD_REQUEST_NEW_APPLICATION_FORM_MESSAGE';
export const CHANGE_TOBA_SETTINGS = 'CHANGE_TOBA_SETTINGS';
export const REQUEST_TOBA_MESSAGE = 'REQUEST_TOBA_MESSAGE';
export const RECEIVE_TOBA_MESSAGE = 'RECEIVE_TOBA_MESSAGE';
export const RECEIVE_FAILURE_TOBA_MESSAGE = 'RECEIVE_FAILURE_TOBA_MESSAGE';
//User send reset password email to solicitor user
export const REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR = 'REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR';
export const RECEIVE_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR = 'RECEIVE_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR';
export const RECEIVE_BAD_REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR = 'RECEIVE_BAD_REQUEST_SEND_RESET_PASSWORD_EMAIL_TO_SOLICITOR';
//MANAGE SOLICITOR ACCOUNT
export const REQUEST_UPDATE_SOLICITOR_PASSWORD = 'REQUEST_UPDATE_SOLICITOR_PASSWORD';
export const RECEIVE_UPDATE_SOLICITOR_PASSWORD_RESPONSE = 'RECEIVE_UPDATE_SOLICITOR_PASSWORD_RESPONSE';
export const RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR_PASSWORD = 'RECEIVE_BAD_RESPONSE_UPDATE_SOLICITOR_PASSWORD';
//NOTIFICATIONS FILTERING
export const GET_NOTIFICATION_TYPES = 'GET_NOTIFICATION_TYPES';
export const GET_NOTIFICATION_TYPES_SUCCESS = 'GET_NOTIFICATION_TYPES_SUCCESS';
export const GET_NOTIFICATION_TYPES_FAILED = 'GET_NOTIFICATION_TYPES_FAILED';
export const CHANGE_NOTIFICATIONS_STATUS_FILTER = 'CHANGE_NOTIFICATIONS_STATUS_FILTER';
export const CHANGE_NOTIFICATIONS_CASE_TYPE_FILTER = 'CHANGE_NOTIFICATIONS_CASE_TYPE_FILTER';
export const CLEAR_NOTIFICATIONS_FILTERS = 'CLEAR_NOTIFICATIONS_FILTERS';
//APPLICATION STATUSES
export const REQUEST_GET_APPLICATION_STATUSES = 'REQUEST_GET_APPLICATION_STATUSES';
export const RECEIVE_GET_APPLICATION_STATUSES = 'RECEIVE_GET_APPLICATION_STATUSES';
export const RECEIVE_BAD_REQUEST_GET_APPLICATION_STATUSES = 'RECEIVE_BAD_REQUEST_GET_APPLICATION_STATUSES';
//APPLICATION ACCEPTED STATUSES TRANSITIONS
export const REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS = 'REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS';
export const RECEIVE_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS = 'RECEIVE_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS';
export const RECEIVE_BAD_REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS = 'RECEIVE_BAD_REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS';
//ARTICLE FORM
export const CHANGE_ARTICLE_FORM_SETTINGS = 'CHANGE_ARTICLE_FORM_SETTINGS';
export const ARTICLE_FORM_ATTACHMENTS_CHANGE = 'ARTICLE_FORM_ATTACHMENTS_CHANGE';
export const ARTICLE_FORM_ATTACHMENT_REMOVE = 'ARTICLE_FORM_ATTACHMENT_REMOVE';
export const REQUEST_POST_NEW_ARTICLE = 'REQUEST_POST_NEW_ARTICLE';
export const RECEIVE_POST_NEW_ARTICLE ='RECEIVE_POST_NEW_ARTICLE';
export const FAILED_TO_POST_NEW_ARTICLE = 'FAILED_TO_POST_NEW_ARTICLE';
export const CHANGE_ARTICLE_FORM_INFO_STATE = 'CHANGE_ARTICLE_FORM_INFO_STATE';
//ARTICLES LIST
export const CHANGE_ARTICLES_LIST_SETTINGS = 'CHANGE_ARTICLES_LIST_SETTINGS';
export const PAGE_SHIFT_ARTICLES = 'PAGE_SHIFT_ARTICLES';
export const REQUEST_GET_ARTICLES = 'REQUEST_GET_ARTICLES';
export const RECEIVE_GET_ARTICLES = 'RECEIVE_GET_ARTICLES';
export const RECEIVE_FAILED_RESPONSE_GET_ARTICLES = 'RECEIVE_FAILED_RESPONSE_GET_ARTICLES';
export const REQUEST_PATCH_ARTICLE = 'REQUEST_PATCH_ARTICLE';
export const RECEIVE_PATCH_ARTICLE = 'RECEIVE_PATCH_ARTICLE';
export const RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE = 'RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE';
export const REQUEST_DELETE_ARTICLE = 'REQUEST_DELETE_ARTICLE';
export const RECEIVE_DELETE_ARTICLE = 'RECEIVE_DELETE_ARTICLE';
export const RECEIVE_FAILED_RESPONSE_DELETE_ARTICLE= 'RECEIVE_FAILED_RESPONSE_DELETE_ARTICLE';
export const REQUEST_GET_SELECTED_ARTICLE = 'REQUEST_GET_SELECTED_ARTICLE';
export const RECEIVE_SPECIFIC_ARTICLE = 'RECEIVE_SPECIFIC_ARTICLE';
export const RECEIVE_FAILED_RESPONSE_GET_SPECIFIC_ARTICLE = 'RECEIVE_FAILED_RESPONSE_GET_SPECIFIC_ARTICLE';
export const REQUEST_ARTICLES_MESSAGE = 'REQUEST_ARTICLES_MESSAGE';
export const RECEIVE_ARTICLES_MESSAGE = 'RECEIVE_ARTICLES_MESSAGE';
export const RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE = 'RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE';
//ARTICLES ATTACHMENT DOWNLOAD
export const REQUEST_ARTICLE_ATTACHMENT = 'REQUEST_ARTICLE_ATTACHMENT';
export const RECEIVE_ARTICLE_ATTACHMENT = 'RECEIVE_ARTICLE_ATTACHMENT';
export const RECEIVE_FAILURE_ARTICLE_ATTACHMENT = 'RECEIVE_FAILURE_ARTICLE_ATTACHMENT';

//SOLICITOR ARTICLES LIST
export const CHANGE_SOLICITOR_ARTICLES_LIST_SETTINGS = 'CHANGE_SOLICITOR_ARTICLES_LIST_SETTINGS';
export const PAGE_SHIFT_SOLICITOR_ARTICLES = 'PAGE_SHIFT_SOLICITOR_ARTICLES';
export const REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE = 'REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE';
export const RECEIVE_GET_ARTICLES_SOLICITOR_HOME_PAGE = 'RECEIVE_GET_ARTICLES_SOLICITOR_HOME_PAGE';
export const RECEIVE_FAILED_RESPONSE_GET_ARTICLES_SOLICITOR_HOME_PAGE = 'RECEIVE_FAILED_RESPONSE_GET_ARTICLES_SOLICITOR_HOME_PAGE';
export const REQUEST_GET_ALL_ARTICLES_SUGGESTIONS = 'REQUEST_GET_ALL_ARTICLES_SUGGESTIONS';
export const RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS = 'RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS';
export const RECEIVE_BAD_RESPONSE_GET_ALL_ARTICLES_SUGGESTIONS = 'RECEIVE_BAD_RESPONSE_GET_ALL_ARTICLES_SUGGESTIONS';
//POLICY TAB
export const GET_APPLICATION_IPT = 'GET_APPLICATION_IPT';
export const RECEIVE_APPLICATION_IPT = 'RECEIVE_APPLICATION_IPT';
export const FAILED_TO_RECEIVE_APPLICATION_IPT = 'FAILED_TO_RECEIVE_APPLICATION_IPT';
export const GET_APPLICATIONS_SCHEDULES = 'GET_APPLICATIONS_SCHEDULES';
export const RECEIVE_APPLICATIONS_SCHEDULES = 'RECEIVE_APPLICATIONS_SCHEDULES';
export const FAILED_TO_RECEIVE_APPLICATIONS_SCHEDULES = 'FAILED_TO_RECEIVE_APPLICATIONS_SCHEDULES';
export const GET_SCHEDULE_FOOTER = 'GET_SCHEDULE_FOOTER';
export const RECEIVE_GET_SCHEDULE_FOOTER = 'RECEIVE_GET_SCHEDULE_FOOTER';
export const RECEIVE_BAD_REQUEST_GET_SCHEDULE_FOOTER = 'RECEIVE_BAD_REQUEST_GET_SCHEDULE_FOOTER';
//CASE TYPES
export const GET_CASE_TYPES = 'GET_CASE_TYPES';
export const RECEIVE_CASE_TYPES = 'RECEIVE_CASE_TYPES';
export const FAILED_TO_GET_CASE_TYPES = 'FAILED_TO_GET_CASE_TYPES';
//PREMIUM_SETTINGS_WIZARD
export const RESET_APPLICATION_PREMIUM = 'RESET_APPLICATION_PREMIUM';
export const CHANGE_WIZARD_STEP = 'CHANGE_WIZARD_STEP';
export const CHANGE_PREMIUM_SETTINGS_WIZARD_STORE = 'CHANGE_PREMIUM_SETTINGS_WIZARD_STORE';
export const CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE  = 'CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE';
export const CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR = 'CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR';
export const POST_NEW_PREMIUM_SETTING_WIZARD = 'POST_NEW_PREMIUM_SETTING_WIZARD';
export const RECEIVE_POST_PREMIUM_SETTING_WIZARD = 'RECEIVE_POST_PREMIUM_SETTING_WIZARD';
export const FAILED_TO_POST_PREMIUM_SETTING_WIZARD = 'FAILED_TO_POST_PREMIUM_SETTING_WIZARD';
export const GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES = 'GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES';
export const RECEIVE_PREMIUM_SETTINGS_WIZARD_MESSAGES = 'RECEIVE_PREMIUM_SETTINGS_WIZARD_MESSAGES';
export const FAILED_TO_GET_PREMIUM_SETTINGS_WIZARD_MESSAGES = 'FAILED_TO_GET_PREMIUM_SETTINGS_WIZARD_MESSAGES';
//APPLICATION REFERRAL SETTINGS
export const FAILED_TO_GET_POLICIES = 'FAILED_TO_GET_POLICIES';
//SOLICITOR IMAGES
export const GET_SOLICITOR_IMAGES = 'GET_SOLICITOR_IMAGES';
export const RECEIVE_SOLICITOR_IMAGES = 'RECEIVE_SOLICITOR_IMAGES';
export const FAILED_TO_GET_SOLICITOR_IMAGES = 'FAILED_TO_GET_SOLICITOR_IMAGES';
export const GET_IMAGE_FILE = 'GET_IMAGE_FILE';
export const RECEIVE_IMAGE_FILE = 'RECEIVE_IMAGE_FILE';
export const INCREMENT_IMAGE_COUNTER = 'INCREMENT_IMAGE_COUNTER';
//SOLICITOR HOME PAGE INFO
export const GET_SOLICITOR_HOME_PAGE_INFO = 'GET_SOLICITOR_HOME_PAGE_INFO';
export const RECEIVE_SOLICITOR_HOME_PAGE_INFO = 'RECEIVE_SOLICITOR_HOME_PAGE_INFO';
export const FAILED_TO_GET_SOLICITOR_HOME_PAGE_INFO = 'FAILED_TO_GET_SOLICITOR_HOME_PAGE_INFO';

//APPLICATION NOTIFICATION
export const REQUEST_GET_APPLICATION_NOTIFICATION = 'REQUEST_GET_APPLICATION_NOTIFICATION';
export const RECEIVE_GET_APPLICATION_NOTIFICATION = 'RECEIVE_GET_APPLICATION_NOTIFICATION';
export const RECEIVE_FAILURE_GET_APPLICATION_NOTIFICATION = 'RECEIVE_FAILURE_GET_APPLICATION_NOTIFICATION';

//NOTIFICATIONS INDICATOR
export const REQUEST_GET_NOTIFICATIONS_INDICATOR = 'REQUEST_GET_NOTIFICATIONS_INDICATOR';
export const RECEIVE_GET_NOTIFICATIONS_INDICATOR = 'RECEIVE_GET_NOTIFICATIONS_INDICATOR';
export const RECEIVE_FAILURE_GET_NOTIFICATIONS_INDICATOR = 'RECEIVE_FAILURE_GET_NOTIFICATIONS_INDICATOR';

// NEW APPLICATION
export const UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT = 'UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT';
export const UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_SUCCESS = 'UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_SUCCESS';
export const UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_FAIL = 'UPDATE_FORM_QUESTION_ANSWER_AFTER_SUBMIT_FAIL';
export const OPEN_EDIT_QUESTION_ANSWER_MODAL = 'OPEN_EDIT_QUESTION_ANSWER_MODAL';
export const CLOSE_EDIT_QUESTION_ANSWER_MODAL = 'CLOSE_EDIT_QUESTION_ANSWER_MODAL';

export const FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE = 'FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE';
export const FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_SUCCESS = 'FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_SUCCESS';
export const FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_FAILED = 'FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_ANSWER_UPDATE_FAILED';

export const FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE = 'FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE';
export const FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_SUCCESS = 'FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_SUCCESS';
export const FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_FAILED = 'FETCH_APPLICATION_BY_ID_AFTER_APPLICATION_UPDATE_FAILED';

// QUESTION ANSWERS REVISIONS
export const FETCH_QUESTION_ANSWER_REVISIONS = 'FETCH_QUESTION_ANSWER_REVISIONS';
export const FETCH_QUESTION_ANSWER_REVISIONS_SUCCESS = 'FETCH_QUESTION_ANSWER_REVISIONS_SUCCESS';
export const FETCH_QUESTION_ANSWER_REVISIONS_FAILED = 'FETCH_QUESTION_ANSWER_REVISIONS_FAILED';

//ARAG USER AS SOLICITOR
export const GET_POLICY_AS_SOLICITOR = 'GET_POLICY_AS_SOLICITOR'
export const REQUEST_POST_NEW_APPLICATION_AS_SOLICITOR = 'REQUEST_POST_NEW_APPLICATION_AS_SOLICITOR'

export const GET_POLICY_SCHEDULE = 'GET_POLICY_SCHEDULE'
export const RECEIVE_GET_POLICY_SCHEDULE = 'RECEIVE_GET_POLICY_SCHEDULE'
export const GET_COVERAGE_TYPES = 'GET_COVERAGE_TYPES'
export const RECEIVE_COVERAGE_TYPES = 'RECEIVE_COVERAGE_TYPES'
export const FAILED_GET_COVERAGE_TYPES = 'FAILED_GET_COVERAGE_TYPES'
export const FAIL_GET_POLICY_SCHEDULE = 'FAIL_GET_POLICY_SCHEDULE'
export const GET_COSTS_SUMMARY = 'GET_COSTS_SUMMARY';
export const RECEIVE_COSTS_SUMMARY = 'RECEIVE_COSTS_SUMMARY';
export const FAILED_TO_GET_COSTS_SUMMARY = 'FAILED_TO_GET_COSTS_SUMMARY';